import React from "react";
import GenericList from "@/pages/GenericList";
import { useLang } from "@/context/LangContext";

export function Hosting() {
  const { t } = useLang();
  return <GenericList
    kind="hosting" testKey="hosting"
    title={t("hosting.title")} subtitle={t("hosting.subtitle")} newLabel={t("hosting.new")}
    fields={[
      { key: "name", label: "Name" },
      { key: "provider", label: "Provider" },
      { key: "region", label: "Region" },
      { key: "status", label: "Status", type: "select", options: [
        { value: "active", label: "Active" }, { value: "warning", label: "Warning" }, { value: "down", label: "Down" },
      ]},
      { key: "url", label: "URL" },
      { key: "notes", label: "Notes", type: "textarea", wide: true },
    ]}
  />;
}
export function Domains() {
  const { t } = useLang();
  return <GenericList
    kind="domains" testKey="domains"
    title={t("domains.title")} subtitle={t("domains.subtitle")} newLabel={t("domains.new")}
    fields={[
      { key: "name", label: "Domain" },
      { key: "registrar", label: "Registrar" },
      { key: "expires_at", label: "Expires", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["active", "expiring", "expired"] },
      { key: "notes", label: "Notes", type: "textarea", wide: true },
    ]}
  />;
}
export function SSL() {
  const { t } = useLang();
  return <GenericList
    kind="ssl" testKey="ssl"
    title={t("ssl.title")} subtitle={t("ssl.subtitle")} newLabel={t("ssl.new")}
    fields={[
      { key: "domain", label: "Domain" },
      { key: "issuer", label: "Issuer" },
      { key: "expires_at", label: "Expires", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["valid", "expiring", "expired"] },
    ]}
  />;
}
export function GBP() {
  const { t } = useLang();
  return <GenericList kind="gbp" testKey="gbp" title={t("gbp.title")} subtitle={t("gbp.subtitle")} newLabel={t("gbp.new")}
    fields={[
      { key: "business_name", label: "Business" }, { key: "location", label: "Location" },
      { key: "rating", label: "Rating" }, { key: "url", label: "Profile URL" },
      { key: "notes", label: "Notes", type: "textarea", wide: true },
    ]}
  />;
}
export function SEO() {
  const { t } = useLang();
  return <GenericList kind="seo" testKey="seo" title={t("seo.title")} subtitle={t("seo.subtitle")} newLabel={t("seo.new")}
    fields={[
      { key: "campaign", label: "Campaign" }, { key: "target_url", label: "Target URL" },
      { key: "keywords", label: "Keywords" }, { key: "status", label: "Status", type: "select", options: ["active", "paused", "archived"] },
    ]}
  />;
}
export function Social() {
  const { t } = useLang();
  return <GenericList kind="social" testKey="social" title={t("social.title")} subtitle={t("social.subtitle")} newLabel={t("social.new")}
    fields={[
      { key: "channel", label: "Channel", type: "select", options: ["Instagram", "Facebook", "TikTok", "LinkedIn", "X"] },
      { key: "handle", label: "Handle" }, { key: "followers", label: "Followers" },
      { key: "notes", label: "Notes", type: "textarea", wide: true },
    ]}
  />;
}
export function NFC() {
  const { t } = useLang();
  return <GenericList kind="nfc" testKey="nfc" title={t("nfc.title")} subtitle={t("nfc.subtitle")} newLabel={t("nfc.new")}
    fields={[
      { key: "recipient", label: "Recipient" }, { key: "quantity", label: "Quantity", type: "number" },
      { key: "design", label: "Design" }, { key: "status", label: "Status", type: "select", options: ["ordered", "in_production", "shipped", "delivered"] },
    ]}
  />;
}
export function Uniforms() {
  const { t } = useLang();
  return <GenericList kind="uniforms" testKey="uniforms" title={t("uniforms.title")} subtitle={t("uniforms.subtitle")} newLabel={t("uniforms.new")}
    fields={[
      { key: "item", label: "Item" }, { key: "size", label: "Size" }, { key: "quantity", label: "Quantity", type: "number" },
      { key: "status", label: "Status", type: "select", options: ["ordered", "in_production", "shipped", "delivered"] },
    ]}
  />;
}
export function MobileAppsPage() {
  const { t } = useLang();
  return <GenericList kind="mobile_apps" testKey="mobile_apps" title={t("mobile_apps.title")} subtitle={t("mobile_apps.subtitle")} newLabel={t("mobile_apps.new")}
    fields={[
      { key: "name", label: "App name" },
      { key: "platform", label: "Platform", type: "select", options: ["iOS", "Android", "Both", "Cross-platform"] },
      { key: "version", label: "Version" },
      { key: "status", label: "Status", type: "select", options: ["discovery", "design", "development", "review", "released"] },
    ]}
  />;
}
export function WebsitesPage() {
  const { t } = useLang();
  return <GenericList kind="websites" testKey="websites" title={t("websites.title")} subtitle={t("websites.subtitle")} newLabel={t("websites.new")}
    fields={[
      { key: "name", label: "Site name" }, { key: "url", label: "URL" },
      { key: "stack", label: "Stack" },
      { key: "status", label: "Status", type: "select", options: ["design", "development", "review", "live", "maintenance"] },
    ]}
  />;
}
